// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Rv","wrapper":"i_Rw","category-body":"i_Rx","category-sub-block":"i_Ry","meta":"i_Rz","meta-item":"i_R0","block-image":"i_R1","image":"i_R2","content":"i_R3"};